import type { IEventItem } from '@op/components/ChartsEvents/types';
import type { IOpinionEventFloaterDetail } from '../../OpinionEventFloater';
import { resolveOpinionLineChartEventTypeKey } from '../../utils/eventTypeStyle';

/** 将气泡可见事件列表转为弹窗展示结构 */
export function buildFloaterDetailFromEvents(
  events: IEventItem[] = [],
): IOpinionEventFloaterDetail | null {
  if (!events.length) {
    return null;
  }

  const event_list: Record<string, IEventItem[]> = {};

  events.forEach(event => {
    const typeKey = resolveOpinionLineChartEventTypeKey(event.event_type);
    if (!event_list[typeKey]) {
      event_list[typeKey] = [];
    }
    event_list[typeKey].push(event);
  });

  return {
    count: events.length,
    event_list,
  };
}
